import React, { Component } from 'react';

class BenchManager extends Component {
    constructor() {
        super()
        this.state = {
            option: [1, 2, 3],
            benchId: undefined,
            benchDesc: undefined
        }
        this.onBenchIdChange = this.onBenchIdChange.bind(this);
        this.onBenchDescChange = this.onBenchDescChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onBenchIdChange(e) {
        const value = e.target.value;
        this.setState( (prevState) => {
            return {
                option: prevState.option,
                benchId: value,
                benchDesc: prevState.benchDesc
            }
        })
    }

    onBenchDescChange(e) {
        const value = e.target.value;
        this.setState( (prevState) => {
            return {
                option: prevState.option,
                benchId: prevState.benchId,
                benchDesc: value
            }
        })
    }

    onSubmit(e) {
        e.preventDefault();
        console.log(this.state);
    }

    render() {
        return(
            <div data-test = 'benchManagerComponent' className="container-fluid">
                <div className="row">
                  <div className="mt-5 mx-auto">
                    <div className="card" style={{ width: "800px" }}>
                        <div className="card">
                            <h1 className="card-header" style={{color:"white", fontSize: "100% !important", backgroundColor: "#757AF7"}}>Bench Manager</h1>
                        </div>
                            <div className="card-body">
                                <form onSubmit={this.onSubmit}>
                                  <div className="form-group">
                                    <label htmlFor="benchId">Bench Id</label>
                                    <select className="form-control" id="benchId" onChange={ this.onBenchIdChange }>
                                        <option value="select">Select Bench</option>
                                        {this.state.option.map( (item, index) => {
                                            return <option value={item} key={index}>{item}</option>
                                        })}
                                    </select>
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="benchDescription">Bench Description</label>
                                    <textarea className="form-control" id="benchDescription" rows="5" onChange={this.onBenchDescChange}></textarea>
                                  </div>
                                  <div>
                                    { this.state.benchId && this.state.benchDesc ? undefined : <p style={{ color: "red" }}>Please enter Bench Id and Bench Description</p>}
                                  </div>
                                   <button type="submit" className="btn">Submit</button>
                                </form>
                            </div>
                      </div>
                  </div>
                </div>
            </div>
        )
    }
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

export default BenchManager
